import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { StatusPage, EndpointPage } from '../features/status/pages';
import { LoginPage, SetupPage } from '../features/auth/pages';
import { IncidentPage } from '../features/incidents/pages';
import { LoadingSpinner } from '../shared/components';

const AdminDashboardPage = lazy(() =>
  import('../features/admin/pages').then((m) => ({ default: m.AdminDashboardPage }))
);

function RouteFallback() {
  return (
    <div className="loading-page">
      <LoadingSpinner size="large" text="Loading..." />
    </div>
  );
}

export default function AppRoutes({
  socket,
  isAuthenticated,
  setupComplete,
  onLogin,
  onLogout,
  onSetupComplete,
}) {
  if (!setupComplete) {
    return <SetupPage onSetupComplete={onSetupComplete} />;
  }

  return (
    <Routes>
      <Route path="/" element={<StatusPage socket={socket} />} />
      <Route path="/endpoint/:endpointId" element={<EndpointPage socket={socket} />} />
      <Route path="/incident/:incidentId" element={<IncidentPage />} />
      <Route
        path="/admin"
        element={
          isAuthenticated ? (
            <Suspense fallback={<RouteFallback />}>
              <AdminDashboardPage socket={socket} onLogout={onLogout} />
            </Suspense>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/admin" /> : <LoginPage onLogin={onLogin} />}
      />
    </Routes>
  );
}
